import { FC } from 'react';
import { Breadcrumbs as BaseBreadcrumbs, Link, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Link as BaseLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

import * as CommonSelectors from '../../shared/redux/commonSelectors';
import useMainProgressContext from '../progress/MainProgress/context/MainProgressContext';

import './Breadcrumbs.scss';

interface BreadcrumbsProps {
  title?: string;
}

const Breadcrumbs: FC<BreadcrumbsProps> = (props) => {
  const { t } = useTranslation();
  const breadcrumbs = useSelector(CommonSelectors.breadcrumbs);
  const { show } = useMainProgressContext();

  return (
    <BaseBreadcrumbs aria-label="breadcrumb" className="Breadcrumbs-Wrapper">
      {breadcrumbs.map(({ label, to }) => {
        if (to) {
          return (
            <Link
              color="inherit"
              to={to}
              key={to}
              component={BaseLink}
              onClick={() => {
                show();
              }}
            >
              {t(label)}
            </Link>
          );
        } else {
          return <Typography key={to}>{t(label)}</Typography>;
        }
      })}
      {props.title && <Typography className="title">{t(props.title)}</Typography>}
    </BaseBreadcrumbs>
  );
};

export default Breadcrumbs;
